import { FailedCheckDetails, FailedCheckKeys } from "../types/apis";

export const EXCLUDED_FROM_VALUATIONS = [
  FailedCheckKeys.SCRAPPED,
  FailedCheckKeys.STOLEN,
  FailedCheckKeys.IMPORTED,
  FailedCheckKeys.EXPORTED,
  FailedCheckKeys.TRADE_FINANCE,
  FailedCheckKeys.COLOUR_CHANGE,
];

export const excludeFromValuation = (checks: FailedCheckDetails[]): boolean => {
  if (!Array.isArray(checks) || checks.length === 0) return false;

  return checks.some((check) =>
    EXCLUDED_FROM_VALUATIONS.includes(check.key as FailedCheckKeys),
  );
};

export const getFailedChecks = (checks: FailedCheckDetails[]): string[] => {
  if (!Array.isArray(checks) || checks.length === 0) return [];

  return checks
    .filter((check) =>
      EXCLUDED_FROM_VALUATIONS.includes(check.key as FailedCheckKeys),
    )
    .map((check) => check.value);
};
